/**
 * This file contains the reducer for the deleted package tutorial.
 *
 * The deleted package tutorial is the pop up that appears when a student
 * clicks on a deleted package.
 */

import { fromJS } from 'immutable';

import { RESET_TUTORIALS } from '../actions';

import {
    DISMISS_DELETED_PACKAGE_TUTORIAL,
    TRIGGER_DELETED_PACKAGE_TUTORIAL,
} from '../tutorial-actions/deleted-package';

export const DELETED_PACKAGE_TUTORIAL_KEY = 'deletedPackageTutorial';

const INITIAL_STATE = fromJS({
    state: undefined,
});

export function deletedPackageTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;
        case TRIGGER_DELETED_PACKAGE_TUTORIAL:
            return state.set('state', action.packageID);
        case DISMISS_DELETED_PACKAGE_TUTORIAL:
            return state.set('state', undefined);
    }
    return state;
}
